export var props = {
  active: {
    type: String,
    required: true
  },
  immediate: {
    type: Boolean,
    required: false,
    default: true
  },
  tabs: {
    type: [Object, Array],
    required: true
  },
  innerTabsConfig: {
    type: Object,
    required: false,
    default: () => {
      return {
        id: 'cb-rank-tabs'
      };
    }
  },
  requestData: {
    type: Function,
    required: false
  },
  tabRankConfig: {
    type: [Object, Array],
    required: false,
    default: () => ({})
  },
  actId: {
    type: String,
    required: false,
    default: ''
  }
};